import {
	db,
	IModel,
	IVIPCapabilityRequestBase,
	VIPCapability,
	VIPCapabilityRequestBase,
} from "@/loader";

/**
 * Capability Request Interface.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		2.0.0
 * @since		1.0.0
 */
export interface IVIPCapabilityRequest extends IVIPCapabilityRequestBase {
}

export enum VIPCapabilityRequestDocument {
	ipsCertificatesSummary = "ips_certificates_summary",
	request = "request",
	requestForm = "request_form",
}

/**
 * Capability Request Class.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		2.0.0
 * @since		1.0.0
 */
export class VIPCapabilityRequest extends VIPCapabilityRequestBase implements IVIPCapabilityRequest, IModel<IVIPCapabilityRequest> {
	constructor (data: IVIPCapabilityRequest = {}) {
		super(data);
	}

	/**
	 * Get Capabilities
	 */
	public get capabilities(): VIPCapability[] {
		return db.capabilities.list.filter(x => x.fk_capability_request === this.id).sort((a, b) => a.ip?.code && b.ip?.code ? a.ip.code - b.ip.code : 0);
	}

	public load(data: IVIPCapabilityRequest) {
		super.load(data);
	}

	public update(data: IVIPCapabilityRequest) {
		super.update(data);
	}

	public ipsCertificatesSummaryUrl(token: string) {
		return this.documentUrl(VIPCapabilityRequestDocument.ipsCertificatesSummary, token);
	}

	public requestUrl(token: string) {
		return this.documentUrl(VIPCapabilityRequestDocument.request, token);
	}

	public requestFormUrl(token: string) {
		return this.documentUrl(VIPCapabilityRequestDocument.requestForm, token);
	}

	private documentUrl(key: VIPCapabilityRequestDocument, token: string) {
		return `/?capability_request=${this.id}&type=${key}&token=${token}`;
	}
}
